import { createFileRoute } from '@tanstack/react-router'
import { InstanceCompliance } from '@/features/compliance'

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/compliance'
)({
  component: InstanceCompliance,
})
